import script from "./ServiceItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./ServiceItem.vue?vue&type=script&lang=ts&setup=true"

import "./ServiceItem.vue?vue&type=style&index=0&id=15eb08d7&scoped=true&lang=scss"

import exportComponent from "/home/forge/saf.appbci.online/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15eb08d7"]])

export default __exports__